<div class="message" [ngClass]="{ expired: expired }">
  <div (click)="open = !open" class="message-time">
    <icon-toggle-open-close [open]="open"></icon-toggle-open-close>
    <b>
      {{ message.timestamp | date : formatDateTime }}
    </b>
  </div>
  <div *ngIf="open" class="message-body">
    {{ message.message }}
  </div>
</div>
